import { render, staticRenderFns } from "./DevMethodologyRow.vue?vue&type=template&id=637753dc"
import script from "./DevMethodologyRow.vue?vue&type=script&lang=js"
export * from "./DevMethodologyRow.vue?vue&type=script&lang=js"
import style0 from "./DevMethodologyRow.vue?vue&type=style&index=0&id=637753dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports